<template>
    <!-- Only render the export button if there is an active URL and the loader is not active -->
    <div v-if="activeUrlExists && !loaderStore.isLoading">
      <v-btn variant="elevated" color="primary" @click="exportData">
        <template v-if="!isMobile">
          Export
        </template>
        <template v-else>
          <v-icon>mdi-export</v-icon>
        </template>
      </v-btn>
    </div>
  </template>
  
  <script lang="ts" setup>
  import { computed } from 'vue';
  import { useDisplay } from 'vuetify';
  import { useActiveUrlStore } from '@/store/activeUrlStore';
  import { useLoaderStore } from '@/store/loaderStore';
  import exportCategoriesAndProductsToJson from '@/utils/exportUtils';
  
  const activeUrlStore = useActiveUrlStore();
  const loaderStore = useLoaderStore();
  
  // Check if there is an active URL
  const activeUrlExists = computed(() => !!activeUrlStore.activeUrl);
  
  // Use Vuetify's useDisplay composable to detect mobile devices
  const { mobile } = useDisplay();
  const isMobile = computed(() => mobile.value);
  
  // Function to call the export utility
  const exportData = () => {
    exportCategoriesAndProductsToJson();
  };
  </script>
  